var map = {
	"./google-laurel-da-DK.svg": 53701,
	"./google-laurel-de-DE.svg": 19679,
	"./google-laurel-en-GB.svg": 94509,
	"./google-laurel-en-US.svg": 76386,
	"./google-laurel-es-ES.svg": 80961,
	"./google-laurel-es-MX.svg": 93954,
	"./google-laurel-fr-FR.svg": 63429,
	"./google-laurel-it-IT.svg": 11247,
	"./google-laurel-nb-NO.svg": 90264,
	"./google-laurel-nl-NL.svg": 45341,
	"./google-laurel-pl-PL.svg": 16353,
	"./google-laurel-pt-BR.svg": 42945,
	"./google-laurel-pt-PT.svg": 89617,
	"./google-laurel-sv-SE.svg": 2372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;